import { createSlice } from '@reduxjs/toolkit'
import { EXPIRE_SESSION, LOGOUT } from 'actions/auth'

export type LegalDocsBlockState = {
  enforced: boolean
}

// Backend returns this body on a 403 when an admin user tries to access a
// merchant-scoped endpoint while the merchant is non-compliant under the
// `mx-legal-docs-enforcement=block` rollout. Receiving it implies the user
// is an admin, since the backend only enforces against admins.
const initialState: LegalDocsBlockState = {
  enforced: false,
}

const slice = createSlice({
  name: 'legalDocsBlock',
  initialState,
  reducers: {
    legalDocsRequired: state => {
      state.enforced = true
    },
    legalDocsCleared: state => {
      state.enforced = false
    },
  },
  extraReducers: builder => {
    builder.addMatcher(
      action => action.type === LOGOUT || action.type === EXPIRE_SESSION,
      () => initialState
    )
  },
})

export const { legalDocsRequired, legalDocsCleared } = slice.actions
export const reducer = slice.reducer

export const selectLegalDocsEnforced = (state: {
  legalDocsBlock?: LegalDocsBlockState
}) => state.legalDocsBlock?.enforced ?? false
